<template lang="pug">
   .wb
      notifications

      template(v-if="loaded")
         login(v-if="!isAuth")
         tac(v-else-if="tacAcceptRequired")
         router-view(v-else="")

</template>

<style lang="less">
.wb {
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   min-height: 100vh;
}
</style>

<script>

import 'normalize.css';
import './main.less';

import Login from './components/login/login.vue';
import Tac from './components/tac/tac.vue';
import Notifications from './components/notifications/notifications.vue';
import store from './store';

import { mapState } from 'vuex';

import './layout.helper';

export default {
   name: 'App',
   store,
   components: { Login, Notifications, Tac },
   computed: mapState({
      loaded: state => !state.auth.loading,
      isAuth: state => state.auth.isAuth,
      tacAcceptRequired: state => state.auth.tacAcceptRequired
   })
};
</script>

<style>
</style>
